
import {AdminLayout, } from "../layouts";
import {UsersAdmin, SettingsAdmin, DashboardAdmin, LeadsAdmin, ExpensesAdmin, PurchasesAdmin, FinanceYearlyComparison} from "../pages/Admin"
import { FinanceDashboard } from "../pages/Admin/FinanceDashboard";
import { LeadsTableAdmin } from "../pages/Admin/LeadsTableAdmin";
import { SalesAdmin } from "../pages/Admin/SalesAdmin";




const routesAdmin = [
    {
        path: "/admin",
        layout: AdminLayout,
        component: FinanceDashboard,
       

    },{
        path: "/admin/comparative",
        layout: AdminLayout,
        component: FinanceYearlyComparison,      
    },
    {
        path: "/admin/users",
        layout: AdminLayout,
        component: UsersAdmin,
        exact: true
       

    },{
        path: "/admin/settings",
        layout: AdminLayout,
        component: SettingsAdmin,
        exact: true
       

    },{
        path: "/admin/compras",
        layout: AdminLayout,
        component: PurchasesAdmin,
        exact: true
       

    },{
        path: "/admin/ventas",
        layout: AdminLayout,
        component: SalesAdmin,
        exact: true       

    },
    {
        path: "/admin/gastos",
        layout: AdminLayout,
        component: ExpensesAdmin,
        exact: true       

    },
    {
        path: "/admin/leads-table",
        layout: AdminLayout,
        component: LeadsTableAdmin,
        exact: true       

    },
    {
        path: "/admin/leads",
        layout: AdminLayout,
        component: LeadsAdmin,
        exact: true
       

    }
];

export default routesAdmin;